import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import categoryApi from 'src/api/category'
// import dictApi from 'src/api/dict'
import _ from 'lodash'

export const fetchCategoryByGroupId = createAsyncThunk(
  'category/fetchCategoryByGroupId',
  async (groupId) => {
    const response = await categoryApi.getAllCategoryList(groupId)
    // console.log('Category Redux: ', response)
    return response
  }
)

// export const fetchStore = createAsyncThunk(
//   'category/fetchStore',
//   async () => {
//     const response = await dictApi.getDict('store')
//     // console.log('Category Redux: ', response)
//     return response
//   }
// )

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  loading: true,
  error: '',
  status: '',
  categorys: [],
}
const slice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    createCategory(oldState, action) {
      let newCategory = action.payload
      let existCategory = false
      let incomingId = newCategory.id
      let categorys = [...oldState.categorys]
      let index = 0
      //   console.log('newCategory', newCategory)
      if (newCategory.parent) {
        // 添加 (subCategory)
        // console.log(newCategory.parent)

        let parentId = newCategory.parent.id
        categorys.forEach((item) => {
          if (item.id === parentId) {
            if (item.chilren == null) {
              item.children = [...item.children, newCategory]
              //   console.log('children null')
            } else {
              //   console.log('children not null')
              item.children = [...item.children, newCategory]
            }
          }
        })
      } else {
        // 添加 (Category)
        categorys.forEach((item) => {
          // 编辑category
          if (item.id == incomingId) {
            categorys.splice(index, 1, newCategory)
            existCategory = true
          }
          index++
        })
        if (existCategory) {
          oldState.categorys = categorys
        } else {
          // 添加新的Category
          let newCategoryList = [...oldState.categorys, newCategory]
          oldState.categorys = newCategoryList
        }
      }
    },
    deleteCategory(oldState, action) {
      // const deleteId = action.payload.categoryId
      // let categorys = [...oldState.categorys]
      // categorys.splice(categorys.findIndex(function (i) {
      //     return i.id === deleteId
      // }), 1)
      // oldState.categorys = categorys
      let deleteId = action.payload.categoryId
      let categorys = [...oldState.categorys]
      // console.log("deleteId(action) ", deleteId)
      let index = 0
      categorys.forEach((category) => {
        if (category.id == deleteId) {
          // 找category
          //   console.log('找到了父类: ', category)
          categorys.splice(index, 1)
        }
        index++
        let num = 0
        // console.log('category.children', category.children)
        if (category.children.length) {
          // 找subcategory
          category.children.forEach((item) => {
            // console.log('item', item)
            if (item.id == deleteId) {
              // console.log("找到了子类: ", item)
              category.children.splice(num, 1)
              // console.log("itme: ", item)
            }
            num++
          })
        }
      })

      // console.log('after : ', categorys)
      oldState.categorys = categorys
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },

    /* 下面的可能要删掉 */
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },
  extraReducers: {
    [fetchCategoryByGroupId.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchCategoryByGroupId.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.categorys = action.payload
      state.loading = false
    },
    [fetchCategoryByGroupId.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

export const createCategory = (requestBody) => async (dispatch) => {
  const result = await categoryApi.addCategory(requestBody)
  dispatch(slice.actions.createCategory(result))
}

// export const addCategory = (requestBody) => (dispatch) => {
//     const result = categoryApi.addCategory(requestBody);
//     console.log("addCategory: ", result)
//     dispatch(slice.actions.setCategoryRedux(result));
// }

export const deleteCategory = (categoryId) => async (dispatch) => {
  const result = await categoryApi.deleteCategory(categoryId)
  // console.log('delete: ', result, categoryId)
  dispatch(slice.actions.deleteCategory({ categoryId }))
}

// export const editCategory = (categoryId, requestBody) => (dispatch) => {
//     const result = categoryApi.editCategory(categoryId, requestBody);
//     dispatch(slice.action.setCategoryRedux(result));
// }

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

export default slice
